// @flow

import urlJoin from 'url-join';
import { Redirect } from 'react-router';
import type { match as Match } from 'react-router';

import adminPage from '@app/hocs/admin-page';
import type { MessageTranslator } from '@oneflowab/pomes';
import automationRulesReducer from '@app/reducers/entities/automation-rules';
import { AutomationRuleName } from '@app/components/automation-rule-name';

import AutomationRuleDetails from './details';

export type Props = {
  match: Match;
};

type AutomationRuleModule = {
  props: {
    automationRule: Oneflow.AutomationRule;
    fetchAutomationRule: (arg: number) => void;
    match: Match;
    message: MessageTranslator;
    updateState: ReturnType<typeof automationRulesReducer.getUpdateSelector>;
    removeState: ReturnType<typeof automationRulesReducer.getRemoveSelector>;
  };
};

export const AutomationRuleComponent = ({ match }: Props) => (
  <Redirect
    from={match.path}
    to={urlJoin(match.url, '/details')}
  />
);

export const automationRuleModule = ({ props }: AutomationRuleModule) => ({
  title: <AutomationRuleName automationRule={props.automationRule} />,
  showAsLink: false,
  modules: [
    [
      {
        path: '/details',
        title: props.message({
          id: 'Details',
          comment: 'Tab title for data retention details.',
        }),
        section: props.message({
          id: 'Data Retention', // TODO: Rename to Automation Rules when ready
          comment: 'Used as the title for the section.',
        }),
        component: AutomationRuleDetails,
      },
    ],
  ],
  componentDidMount: () => {
    props.fetchAutomationRule(props.match.params.id);
  },
  componentDidUpdate: (prevProps: Props) => {
    const updateStateChanged =
      props.updateState.success !== prevProps.updateState.success &&
      props.updateState.success === true;
    const removeStateChanged =
      props.removeState.success !== prevProps.removeState.success &&
      props.removeState.success === true;

    if (updateStateChanged || removeStateChanged) {
      props.fetchAutomationRule(props.match.params.id);
    }
  },
});

export default adminPage(automationRuleModule)(AutomationRuleComponent);
